import {defineNuxtPlugin} from 'nuxt/app';
import {useFeatureFlagsStore} from '../stores/feature-flags.store';

export default defineNuxtPlugin({
    name: 'nuxt-search-load-ff',
    dependsOn: ['backend-api-cookies'],
    async setup() {
        const {loadFeatureFlags} = useFeatureFlagsStore();
        await loadFeatureFlags();
    },
});
